import { createContact } from "@app/scripts/api/emarsys"
import { formatPhoneNumber } from "@app/scripts/utils"

class EmarsysSignupForm extends HTMLElement {
  form: HTMLFormElement | null = null
  submitButton: HTMLButtonElement | null = null
  errorState: HTMLDivElement | undefined = undefined
  successState: HTMLParagraphElement | undefined = undefined
  formTitle: HTMLHeadingElement | undefined = undefined

  constructor() {
    super()
  }

  connectedCallback() {
    this.form = this.querySelector("form")!
    console.assert(this.form, "Form not found")
    this.form.addEventListener("submit", this.handleSubmit)

    this.submitButton = this.form.querySelector("button[type='submit']")
    console.assert(this.submitButton, "Submit button not found")

    this.formTitle =
      (this.querySelector(".form-title") as HTMLHeadingElement) || undefined
    this.errorState =
      (this.querySelector(".error-state") as HTMLDivElement) || undefined
    this.successState =
      (this.querySelector(".success-state") as HTMLParagraphElement) ||
      undefined
  }

  handleSubmit = async (event: Event) => {
    event.preventDefault()

    this.submitButton!.disabled = true
    this.clearErrorState()

    if (!this.validateForm()) {
      this.submitButton!.disabled = false
      return
    }

    const formData = new FormData(this.form!)
    const data: { [key: string]: string } = {
      contactListId: this.dataset.contactListId || "",
      countryCode: this.dataset.countryCode || "",
    }
    formData.forEach((value, key) => {
      data[key] = value.toString()
    })

    let res: unknown
    try {
      res = await createContact(data)
    } catch (e) {
      console.error(e)
      this.showError("An error occurred while submitting the form.")
      return
    } finally {
      this.submitButton!.disabled = false
    }

    if (this.dataset.storageKey) {
      localStorage.setItem(this.dataset.storageKey, "true")
    }

    console.log("[Emarsys signup form] Form submitted successfully", res)
    this.showSuccessState()
  }

  clearErrorState = () => {
    if (!this.errorState) return
    this.errorState.style.display = "none"
  }

  showError(error: string) {
    if (!this.errorState) return
    this.errorState.style.display = "block"
    this.errorState.textContent = error
  }

  validateForm = (): boolean => {
    if (!this.validatePhoneNumber()) {
      return false
    }

    return true
  }

  validatePhoneNumber = (): boolean => {
    const mobileInput = this.form!.querySelector("#mobile") as HTMLInputElement
    const phone = mobileInput.value.trim()
    const formattedPhone = formatPhoneNumber(phone)
    const isValid = !!formattedPhone
    console.log("[Emarsys signup form] isValid", isValid, formattedPhone)
    const error = this.form!.querySelector(
      "#mobile-error"
    ) as HTMLParagraphElement
    error.style.display = isValid ? "none" : "block"
    return isValid
  }

  showSuccessState = () => {
    const successTitle =
      this.dataset.successTitle || "Thank you for subscribing."
    const successMessage =
      this.dataset.successMessage ||
      "We have sent you an email to confirm your sign up."

    if (this.formTitle) {
      this.formTitle.textContent = successTitle
    }

    if (this.successState) {
      this.successState.textContent = successMessage
      this.successState.style.display = "block"
    }

    ;(
      this.querySelectorAll(
        "form > *:not(.form-title):not(.success-state)"
      ) as NodeListOf<HTMLElement>
    ).forEach((el) => {
      el.style.display = "none"
    })
  }
}

customElements.define("emarsys-signup-form", EmarsysSignupForm)
